import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#B22335', // Main brand color
      light: '#D85566',
      dark: '#8B1A29',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#FFD700', // Gold accent color
      light: '#FFED4E',
      dark: '#B8A000',
      contrastText: '#1C1C1C',
    },
    background: {
      default: '#F8F8F8', // Clean background
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1C1C1C', // Main typography color
      secondary: '#4B4B4B', // Industrial elements
    },
    grey: {
      100: '#F8F8F8',
      300: '#D3D3D3', // Equipment tones
      500: '#4B4B4B', // Industrial elements
      900: '#1C1C1C',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '3.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
      color: '#1C1C1C',
    },
    h2: {
      fontSize: '2.75rem',
      fontWeight: 600,
      lineHeight: 1.3,
      color: '#1C1C1C',
    },
    h3: {
      fontSize: '2.25rem',
      fontWeight: 600,
      lineHeight: 1.4,
      color: '#1C1C1C',
    },
    h4: {
      fontSize: '1.75rem',
      fontWeight: 500,
      lineHeight: 1.4,
      color: '#1C1C1C',
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.5,
      color: '#1C1C1C',
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.5,
      color: '#1C1C1C',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
      color: '#1C1C1C',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.6,
      color: '#4B4B4B',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
          padding: '12px 24px',
          fontSize: '1rem',
        },
        contained: {
          boxShadow: '0 4px 12px rgba(178, 35, 53, 0.3)',
          '&:hover': {
            boxShadow: '0 6px 16px rgba(178, 35, 53, 0.4)',
            transform: 'translateY(-2px)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          '&:hover': {
            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)',
            transform: 'translateY(-4px)',
          },
          transition: 'all 0.3s ease-in-out',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#1C1C1C',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

export default theme;
